<template>
    <v-container>
        <v-row class="contentRow">
            <v-col cols="12">
                <h1 class="mb-2">Add user</h1>
            </v-col>

            <v-col align="center">
                <v-form v-model="valid">
                    <v-col>
                        <v-text-field
                            outlined
                            width="50%"
                            label="First name"
                            v-model="firstname"
                            :rules="[rules.inputRules]"
                        />
                    </v-col>
                    <v-col>
                        <v-text-field
                            outlined
                            width="50%"
                            label="Last name"
                            v-model="lastname"
                            :rules="[rules.inputRules]"
                        />
                    </v-col>
                    <v-col>
                        <v-text-field
                            outlined
                            width="50%"
                            label="E-mail"
                            v-model="email"
                            :rules="[rules.inputRules]"
                        />
                    </v-col>
                    <v-col>
                        <secure-password-field
                            outlined
                            label="Password"
                            v-model="password"
                            :visible="showNew"
                            class="input-group--focused"
                            :rejection-errors="passwordRejectionErrors"
                            :append-icon="showNew ? 'fas fa-eye' : 'fas fa-eye-slash'"
                            @click:append="showNew = !showNew"
                        />
                    </v-col>
                    <v-col>
                        <secure-password-field
                            outlined
                            label="Confirm Password"
                            v-model="confirmPassword"
                            :visible="showConfirm"
                            :show-guidance="false"
                            :enforce-policy="false"
                            :rules="[rules.inputRules, rules.passwordMatch]"
                            :append-icon="showConfirm ? 'fas fa-eye' : 'fas fa-eye-slash'"
                            @click:append="showConfirm = !showConfirm"
                        />
                    </v-col>
                    <v-col>
                        <v-alert
                            color="primary"
                            type="info"
                        >
                        Note: <b>{{(firstname || lastname) ? firstname+" "+lastname : "The new user"}}</b> must verify their e-mail address before logging in. A verification e-mail will be sent to <b>{{email || "their e-mail"}}</b> when you click 'Add user'
                        </v-alert>
                    </v-col>

                    <v-col>
                        <v-btn
                            color="primary"
                            @click="addUser(firstname, lastname, email, password)"
                            :disabled="!valid"
                        >
                        Add user</v-btn>
                    </v-col>
                </v-form>
            </v-col>

        </v-row>
    </v-container>
    
</template>

<script>
import UsersAPI from "../api/connections/users"
import LoadingState from "../consts/LoadingState"
import SecurePasswordField from "../components/SecurePasswordField.vue"
import { extractApiErrorDetails } from "../utils/recaptcha"

export default {
	name: "Add user",
	components: { SecurePasswordField },
	data() {
		return {
			showNew: false,
			showConfirm: false,
			valid: false,
			email: null,
			password: null,
			firstname: null,
			lastname: null,
			confirmPassword: null,
			passwordType: "password",
			passwordRejectionErrors: [],
			rules: {
				inputRules:  v => !!v || "Field is required!" ,
				passwordMatch: ()=>true
			}
		}
	},
	created() {
		this.rules.passwordMatch = () => this.password == this.confirmPassword || "Confirm password does not match new password."
	},
	methods: {

		addUser: function(firstname, lastname, email, password) {
			this.passwordRejectionErrors = []
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Adding User...",
				{ root: true }
			)

			UsersAPI.addUser(firstname, lastname, email, password)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Sucessfully added user!",
						{ root: true }
					)
					this.$router.push({
						name: "Users List"
					})
				})
				.catch(reason => {
					const details = extractApiErrorDetails(reason)
					if (details.length) {
						this.passwordRejectionErrors = details
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
                
       
		}
	}
}
</script>